<mat-form-field [appearance]="appearance" class="w-full" [subscriptSizing]="subscriptSizing">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select
    #selectElem
    [placeholder]="placeholder"
    [formControl]="formControl"
    [multiple]="multiple"
    [compareWith]="compareFn"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="selectOpened($event)"
  >
    <div class="box-search flex flex-col">
      <div class="flex" *ngIf="enableSearch">
        <mat-checkbox
          *ngIf="multiple"
          color="primary"
          class="box-select-all"
          [(ngModel)]="selectAllChecked"
          (change)="toggleSelectAll($event)"
        ></mat-checkbox>
        <input
          #searchInput
          type="text"
          [ngClass]="{ 'pl-1': !multiple }"
          (input)="filterItem(searchInput.value)"
          [placeholder]="selectPlaceholder"
        />
        <div class="box-search-icon" (click)="filterItem(''); searchInput.value = ''">
          <button mat-icon-button class="search-button">
            <mat-icon class="mat-24" aria-label="Search icon">clear</mat-icon>
          </button>
        </div>
      </div>
      <mat-progress-bar mode="indeterminate" color="primary" [hidden]="!IS_LOADING"></mat-progress-bar>
    </div>
    <mat-select-trigger>
      {{ onDisplayString }}
    </mat-select-trigger>
    <mat-option *ngFor="let option of options; trackBy: trackByFn" [disabled]="option.disabled" [value]="option">
      <div class="value-container">
        <div class="option-unit" *ngIf="option.unit_id !== (activeUnit$ | async)?.id && option.unit && option.unit_id !== option.id">
          {{ option.unit.title }}
        </div>
        <div class="option-unit" *ngIf="option.parent">{{ option.parent.title }}</div>
        <div class="option-value">{{ option[display] }}</div>
      </div>
    </mat-option>
  </mat-select>
  <mat-hint style="color: red" *ngIf="showErrorMsg">{{ errorMsg }}</mat-hint>
</mat-form-field>
